export interface CookieArticle {
  title: string;
  content: {
    mainText?: string;
    bulletPoints?: string[];
    additionalText?: string[];
    contactInfo?: string;
  }[];
}

export const cookiesData: CookieArticle[] = [
  {
    title: "Politique de cookies",
    content: [
      {
        mainText:
          "Le site espacecadet.com utilise principalement des traceurs strictement nécessaires à son fonctionnement technique.",
      },
      {
        additionalText: [
          "Cette page précise les catégories de cookies/traceurs utilisés et vos moyens de paramétrage.",
        ],
      },
    ],
  },
  {
    title: "Traceurs strictement nécessaires",
    content: [
      {
        mainText:
          "Ces traceurs permettent le rendu du site, la sécurité technique et la stabilité de navigation.",
      },
      {
        bulletPoints: [
          "Fonctionnement technique de la plateforme",
          "Sécurité et prévention des abus",
          "Équilibrage et distribution des contenus",
        ],
      },
      {
        additionalText: [
          "Ces traceurs ne servent pas à la publicité comportementale.",
        ],
      },
    ],
  },
  {
    title: "Mesure d'audience et cookies tiers",
    content: [
      {
        mainText:
          "À la date de mise à jour de cette page, aucun outil publicitaire n'est activé sur le site.",
      },
      {
        additionalText: [
          "En cas d'ajout futur de traceurs non essentiels (mesure d'audience avancée, services tiers, etc.), une mise à jour des pages d'information et du mécanisme de recueil du consentement sera appliquée.",
        ],
      },
    ],
  },
  {
    title: "Durée de conservation",
    content: [
      {
        bulletPoints: [
          "La durée de vie des traceurs techniques dépend de leur fonction et n'excède pas la durée nécessaire au service rendu.",
          "Les données associées sont traitées conformément à la Politique de confidentialité.",
        ],
      },
    ],
  },
  {
    title: "Paramétrer les cookies",
    content: [
      {
        mainText: "Vous pouvez à tout moment :",
      },
      {
        bulletPoints: [
          "Configurer votre navigateur pour bloquer tout ou partie des cookies",
          "Supprimer les cookies déjà enregistrés",
          "Naviguer en mode privé",
        ],
      },
      {
        additionalText: [
          "Le blocage des cookies strictement nécessaires peut dégrader certaines fonctionnalités du site.",
        ],
      },
    ],
  },
  {
    title: "Contact",
    content: [
      {
        mainText:
          "Pour toute question relative aux cookies ou à vos données personnelles :",
      },
      {
        contactInfo: "clementine@espacecadet.com",
      },
    ],
  },
];
